

const AdsInternal = (props) => {
    
    return (
    
    <div id="ads" className="white_transp_box white_box adunit">
        {props.ads?.map((ad, i) => {
               return (props.location === ad.location) ? <div key={i} a_key={i} >
                 <a href={ad.link} >
                    <img src={`https://v2013.02ws.co.il/${ad.img_url}`}  width="96%" alt="ad" className="rounded"/>
                 </a>
                 
             </div> : ''
          })}
    </div>
    );
}

export default AdsInternal; 